document.addEventListener('DOMContentLoaded', () => {
    const Flickity = require('flickity');

    const storySliders = document.querySelectorAll('.twz-element-stories[data-variant="slider"] .twz-element-stories__items');

    storySliders.forEach(storySlider => {
        // Initialiseer Flickity voor elke slider
        const flkty = new Flickity(storySlider, {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            prevNextButtons: true,
            pageDots: false,
            autoPlay: false,
            groupCells: window.innerWidth <= 768 ? 1 : 2,
            on: {
                ready: () => {
                    setButtons(storySlider);
                }
            }
        });
    });
});


const setButtons = (slider) => {
    const prevButton = slider.querySelector('.flickity-prev-next-button.previous');
    const nextButton = slider.querySelector('.flickity-prev-next-button.next');

    if (prevButton && nextButton) {
        const buttonWrapper = document.createElement('div');
        buttonWrapper.classList.add('flickity-button-wrapper');

        buttonWrapper.appendChild(prevButton);
        buttonWrapper.appendChild(nextButton);

        const allButton = slider.closest('.twz-element-stories') ? slider.closest('.twz-element-stories').querySelector('.all-stories') : null;

        const buttonContainer = document.createElement('div');
        buttonContainer.classList.add('flickity-button-container');

        buttonContainer.appendChild(buttonWrapper);

        if (allButton) {
            buttonContainer.appendChild(allButton);
        }

        slider.parentNode.insertBefore(buttonContainer, slider);
    }
}